import { init as initEventBus } from "../utils/eventBus";
import { globalAPI } from "./globalAPI";
import {getCmsLogger} from "./CmsLogger";
import { BreakpointAPI } from "ngim-breakpoint-api";
import { FabAPI } from "ngim-fab-api";
import { apiMethods as HeaderAPI } from "./header/headerMethods";


const API_NAME = {
  BREAKPOINT: 'breakpoint',
  FAB: 'fab',
  HEADER: 'header',
  LOGGER: 'logger'
}


export function initAPI() {
  initEventBus();

  try {
      globalAPI.add(API_NAME.LOGGER, getCmsLogger());
  }
  catch (error) {
      console.error('failed to initialize the Init Logger API:', error);
  }

  try {
    globalAPI.add(API_NAME.BREAKPOINT, BreakpointAPI);
  } catch (error) {
    console.error("failed to initialize the Breakpoint API:", error);
  }

  try {
    globalAPI.add(API_NAME.FAB, FabAPI);
  } catch (error) {
    console.error("failed to initialize the Fab API:", error);
  }

  try {
    globalAPI.add(API_NAME.HEADER, HeaderAPI);
  } catch (error) {
    console.error("failed to initialize the Header API:", error);
  }
}



// WEBPACK FOOTER //
// ./src/js/api/initAPI.js